// @flow

export function handleWarning(error: any) {
  getHandlerImpl()(error);
}

type HandlerWarningImpl = (error: any) => void;

function getHandlerImpl(): HandlerWarningImpl {
  if (ENV_CONSTANTS.ENV !== 'production' || !window.Rollbar)
    return consoleWarningHandler;

  return rollbarWarningHandler;
}

function consoleWarningHandler(error: any) {
  /* eslint-disable-next-line */
  console.warn(error);
}

function rollbarWarningHandler(error: any) {
  window.Rollbar.warning(error);
}
